import { render, staticRenderFns } from "./best-deals.vue?vue&type=template&id=2e98b9f0&"
import script from "./best-deals.js?vue&type=script&lang=js&"
export * from "./best-deals.js?vue&type=script&lang=js&"
import style0 from "./best-deals.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports